
import { defineComponent } from "vue";
import listResultAdmissionSentMail from "@/components/customers/marketingCampaigns/listResultAdmissionSentMail.vue";
import Permission from "@/core/config/Permission";

//Trang chỉ là khung tiêu đề + danh sách chiến dịch (component con tự lo card/bảng/modal).
//Đã bỏ Datatable/resultSentMail và state của bố cục 2 tab cũ — không còn chỗ nào dùng.
export default defineComponent({
  name: "customers-listing",
  components: {
    listResultAdmissionSentMail,
  },
  setup() {
    return {
      Permission,
    };
  },
});
